"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
class ContentFilesProvider extends DataProvider_1.default {
    get fragments() {
        return {
            ContentFile: () => `
      ... on ContentFile {
        id
        mediaType
        name
        publicAccess
        setId
        size
        width
        height
        duration
        sort
        title
        uploadTime
        urlPart
        uuid
        processingStatus
      }`,
        };
    }
    search({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query({
                query: graphql_tag_1.default `
        query ContentFileSearch($data: InputContentFileSearch!) {
          contentFileSearch(data: $data) {
            result {
              ${this.getFragment("ContentFile")}
            }
            hasNextPage
            hasPrevPage
            page
            size
            totalPages
            totalRecords
          }
        }
      `,
                variables: { data },
            });
            return resp.data.contentFileSearch;
        });
    }
    create({ setId, data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation ContentFileCreate($setId: ID!, $data: InputContentFileCreate!) {
          contentFileCreate(setId: $setId, data: $data) {
            ${this.getFragment("ContentFile")}
          }
        }
      `,
                variables: { setId, data },
            });
            return resp.data.contentFileCreate;
        });
    }
    update({ setId, data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation ContentFileUpdate($setId: ID!, $data: InputContentFileUpdate!) {
          contentFileUpdate(setId: $setId, data: $data) {
            ${this.getFragment("ContentFile")}
          }
        }
      `,
                variables: { setId, data },
            });
            return resp.data.contentFileUpdate;
        });
    }
    delete({ setId, id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation ContentFileDelete($setId: ID!, $id: ID!) {
          contentFileDelete(setId: $setId, id: $id)
        }
      `,
                variables: { setId, id },
            });
            return resp.data.contentFileDelete;
        });
    }
    getUploadUrls({ count, setId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query({
                query: graphql_tag_1.default `
        query ContentFile($setId: ID!, $count: Int!) {
          contentFileUploadUrls(setId: $setId, count: $count) {
            ${this.getFragment("FileUploadResponse")}
          }
        }
      `,
                variables: { setId, count },
            });
            if (!resp)
                throw new Error("Can't get upload data");
            return resp.data.contentFileUploadUrls;
        });
    }
}
exports.ContentFilesProvider = ContentFilesProvider;
//# sourceMappingURL=ContentFilesProvider.js.map